import { APP_CONFIG } from '@constants';

const upload = require('superagent');

export const UPDATE_TITLE_FIELD = 'predictAndWin/UPDATE_TITLE_FIELD';
export const UPDATE_SUBTITLE_FIELD = 'predictAndWin/UPDATE_SUBTITLE_FIELD';
export const UPDATE_BUTTON_FIELD = 'predictAndWin/UPDATE_BUTTON_FIELD';
export const UPDATE_BUTTON_FIELD_SCRATCH_CARD = 'predictAndWin/UPDATE_BUTTON_FIELD_SCRATCH_CARD';
export const UPDATE_BACKGROUND_FIELD = 'predictAndWin/UPDATE_BACKGROUND_FIELD';
export const UPDATE_LAYER_FIELD = 'predictAndWin/UPDATE_LAYER_FIELD';
export const UPDATE_APPCONFIG_FIELD = 'predictAndWin/UPDATE_APPCONFIG_FIELD';
export const UPDATE_BUTTON = 'predictAndWin/UPDATE_BUTTON';
export const UPDATE_GRATIFY_BACKGROUND_FIELD = 'predictAndWin/UPDATE_GRATIFY_BACKGROUND_FIELD';
export const UPDATE_CARDCONFIG = 'predictAndWin/UPDATE_CARDCONFIG';
export const UPLOAD_IMAGE_REQUESTED = 'upload/UPLOAD_IMAGE_REQUESTED';
export const UPLOAD_IMAGE_SUCCESS = 'upload/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = 'upload/UPLOAD_IMAGE_FAILURE';

export const SAVE_CONFIG_REQUESTED = 'save/SAVE_CONFIG_REQUESTED';
export const SAVE_CONFIG_SUCCESS = 'save/SAVE_CONFIG_SUCCESS';
export const SAVE_CONFIG_FAILURE = 'save/SAVE_CONFIG_FAILURE';

export const UPDATE_CONFIG_REQUESTED = 'update/UPDATE_CONFIG_REQUESTED';
export const UPDATE_CONFIG_SUCCESS = 'update/UPDATE_CONFIG_SUCCESS';
export const UPDATE_CONFIG_FAILURE = 'update/UPDATE_CONFIG_FAILURE';

export const GET_CONFIG_REQUESTED = 'get/GET_CONFIG_REQUESTED';
export const GET_CONFIG_SUCCESS = 'get/GET_CONFIG_SUCCESS';
export const GET_CONFIG_FAILURE = 'get/GET_CONFIG_FAILURE';

export const DUPLICATE_CONFIG_REQUESTED = 'get/DUPLICATE_CONFIG_REQUESTED';
export const DUPLICATE_CONFIG_SUCCESS = 'get/DUPLICATE_CONFIG_SUCCESS';
export const DUPLICATE_CONFIG_FAILURE = 'get/DUPLICATE_CONFIG_FAILURE';

export const UPDATE_FIELD = 'predictAndWin/UPDATE_FIELD';
export const UPDATE_PAGE = 'predictAndWin/UPDATE_PAGE';
export const UPDATE_LOCALIZATION_FLAG = 'predictAndWin/UPDATE_LOCALIZATION_FLAG';
export const UPDATE_ACTIVE_FLAG = 'predictAndWin/UPDATE_ACTIVE_FLAG';
export const UPDATE_CONFIG_FIELD = 'predictAndWin/UPDATE_CONFIG_FIELD';
export const REMOVE_CONFIG = 'predictAndWin/REMOVE_CONFIG';
export const CLEAR_STATE = 'predictAndWin/CLEAR_STATE';
export const UPDATE_BUTTON_CONFIG = 'predictAndWin/UPDATE_BUTTON_CONFIG';
export const UPDATE_QUESTIONS_FIELD = 'predictAndWin/UPDATE_QUESTIONS_FIELD';
export const UPDATE_COLLAPSE = 'predictAndWin/UPDATE_COLLAPSE';
export const UPDATE_ACTIVITY_COLLAPSE = 'predictAndWin/UPDATE_ACTIVITY_COLLAPSE';

export const UPDATE_LEADGEN_FIELD = 'predictAndWin/UPDATE_LEADGEN_FIELD';
export const UPDATE_FORMDISPLAY_CONFIG = 'predictAndWin/UPDATE_FORMDISPLAY_CONFIG';
export const UPDATE_ADDSETTINGS_CONFIG = 'predictAndWin/UPDATE_ADDSETTINGS_CONFIG';
export const UPDATE_DISPLAYWIZARD = 'predictAndWin/UPDATE_DISPLAYWIZARD';


const initialState = {
  loading: false,
  loaded: false,
  error: false,
  initialValues: {
    fontTitlePositions: [],
    buttonFormatWidth: [],
    buttonFormatRadius: [],
    buttonFormatShadow: [],
    outlineStyles: [],
    spinButtonWidth: [],
    spinButtonRadius: [],
    spinButtonShadow: [],
    fonts: [],
    fontStrength: [],
    fontSize: [],
    questionType: [],
    scratchType: [],
    fontPositions: [],
    buttonAction: [],
    themeList: [],
  },
  collapse: {
    displayWizard: false,
    // predictionConfigCollapse: false,
    // submissionConfigCollapse: false,
    // resultConfigCollapse: false,
    activityConfigCollapse: false,
    additionalSettings: false,
  },
  activityInnerCollapse: {
    headerConfigCollapse: false,
    predictionConfigCollapse: false,
    submissionConfigCollapse: false,
    resultConfigCollapse: false,
  },
  localizationFlag: '',
  activeNavTab: 'English',
  config: {
    localizationconfig: [
      {
        language: 'English',
        resultHandler: 'ParentApp',
        backgroundRadio: true,
        backgroundColor: '#232323',
        versusIconImage: {
          image: 'https://cdnstg.gamize.com/gamize/templates/predictAndWin/Versus.png',
          imageName: 'Versus.png',
          backgroundError: ''
        },
        backgroundImage: {
          image: '',
          imageName: '',
          backgroundError: '',
        },
        optionType: 'Image',
        versusNeeded: true,
        questionStyle: {
          option: {
            alignment: {
              iconAlignment: 'right',
              textAlignment: 'center'
            },
            defaultStyles: {
              color: '#000000',
              outlineColor: '#6E6E6E',
              borderWidth: '1px',
              radius: '8px',
              iconColor: '#FF0000',
              icon: null,
              iconName: null,
              fontColor: '#ffffff'
            },
            correct: {
              color: '#000003',
              outlineColor: '#00000a',
              borderWidth: '1px',
              radius: '8px',
              iconColor: '#1CAF68',
              icon: 'https://www.googleapis.com/download/storage/v1/b/ec2-us-east-1-1b-dev-images-gamification/o/superQuiz137%2F131%2F2045_correct.png?alt=media',
              iconName: null,
              fontColor: '#ffffff'
            },
            wrong: {
              color: '#000006',
              outlineColor: '#000000',
              borderWidth: '1px',
              radius: '8px',
              iconColor: '#FF0000',
              icon: 'https://www.googleapis.com/download/storage/v1/b/ec2-us-east-1-1b-dev-images-gamification/o/superQuiz137%2F131%2F4783_wrong.png?alt=media',
              iconName: null,
              fontColor: '#ffffff'
            },
            selected: {
              color: '#000000',
              outlineColor: '#6E6E6E',
              borderWidth: '1px',
              radius: '8px',
              iconColor: '#1CAF68',
              icon: 'https://www.googleapis.com/download/storage/v1/b/ec2-us-east-1-1b-dev-images-gamification/o/superQuiz137%2F131%2F2045_correct.png?alt=media',
              iconName: null,
              fontColor: '#ffffff'
            }
          }
        },
        optionStyles: {
          fontColor: {
            color: '#000000'
          },
          fontSize: '18',
          fontStrength: '600',
          fontFamily: 'Outfit, sans-serif',
          align: 'left',
        },
        mode: 'save',
        title: {
          text: 'Heading',
          titleError: '',
          disableSave: false,
          templateName: {
            text: ''
          },
          templateError: ''
        },
        subtitle: {
          text: 'Sub heading',
          titleError: '',
        },
        displayWizard: {
          themeId: '',
          themeIdError: '',
          displayType: 'popup',
          winningText: {
            img: '',
            imageName: '',
            text: '',
            color: '#000000',
            font: {
              size: '14',
              strength: '400',
              family: 'Outfit, sans-serif',
              align: 'left',
            },
            error: '',
            errorImg: ''
          },
          losingText: {
            img: '',
            imageName: '',
            text: '',
            color: '#000000',
            font: {
              size: '14',
              strength: '400',
              family: 'Outfit, sans-serif',
              align: 'left',
            },
            error: '',
            errorImg: ''
          },
        },
        formDisplayConfig: {
          labelPosition: 'aboveField',
          bannerImg: 'https://cdnstg.gamize.com/13/spinTheWheel/15/4260_black_friday.png',
          bannerImgName: 'blackFriday',
          bannerImgError: ''
        },
        leadGeneration: {
          answerDeadline: new Date().getTime(),
          resultTiming: new Date().getTime(),
          timerHeader: {
            text: 'Results in',
            color: '#ffffff',
            font: {
              size: '14',
              strength: '400',
              family: 'Outfit, sans-serif',
              align: 'center',
            },
            error: '',
          },
          timeFormat: {
            text: '',
            color: '#ffffff',
            font: {
              size: '14',
              strength: '400',
              family: 'Outfit, sans-serif',
              align: 'center',
            },
            error: '',
          },
          timerNumber: {
            text: '',
            color: '#ffffff',
            font: {
              size: '14',
              strength: '700',
              family: 'Outfit, sans-serif',
              align: 'center',
            },
            error: '',
          },
          timerFieldNameTexts: {
            daysText: 'Days',
            hoursText: 'Hours',
            minutesText: 'Minutes',
          },
          timerColor: '#867D7D',
          localCustomTitle: [],
        },
        buttonConfig: [
          {
            text: {
              text: 'Home',
              color: '#000000',
              font: {
                size: '14',
                strength: '400',
                family: 'Outfit, sans-serif',
                align: 'left',
              },
            },
            textColor: '#000000',
            image: {
              url: '',
              name: ''
            },
            imageError: '',
            width: '75%',
            radius: '30px',
            shadow: '0px 0px',
            shadowColor: '#cdcdcd',
            position: 'left',
            bgColor: '#0b6cff',
            border: '#000000',
            hoverBgColor: '#cdcdcd',
            buttonTextError: '',
            borderWidth: '1px',
            appLink: {
              text: ''
            },
            webLink: {
              text: ''
            },
            appLinkError: '',
            webLinkError: ''
          },
          {
            text: {
              text: 'Home',
              color: '#ffffff',
              font: {
                size: '14',
                strength: '400',
                family: 'Outfit, sans-serif',
                align: 'left',
              },
            },
            textColor: '#000000',
            image: {
              url: '',
              name: ''
            },
            imageError: '',
            width: '75%',
            radius: '30px',
            shadow: '0px 0px',
            shadowColor: '#cdcdcd',
            position: 'left',
            bgColor: '#0b6cff',
            border: '#000000',
            hoverBgColor: '#cdcdcd',
            buttonTextError: '',
            borderWidth: '1px',
            appLink: {
              text: ''
            },
            webLink: {
              text: ''
            },
            appLinkError: '',
            webLinkError: ''
          },
          {
            text: {
              text: 'Home',
              color: '#ffffff',
              font: {
                size: '14',
                strength: '400',
                family: 'Outfit, sans-serif',
                align: 'left',
              },
            },
            textColor: '#000000',
            image: {
              url: '',
              name: ''
            },
            imageError: '',
            width: '75%',
            radius: '30px',
            shadow: '0px 0px',
            shadowColor: '#cdcdcd',
            position: 'left',
            bgColor: '#0b6cff',
            border: '#000000',
            hoverBgColor: '#cdcdcd',
            buttonTextError: '',
            borderWidth: '1px',
            appLink: {
              text: ''
            },
            webLink: {
              text: ''
            },
            appLinkError: '',
            webLinkError: ''
          }
        ],
        allowEdit: true,
        questionIndex: 0,
        questions: [
          {
            name: {
              text: 'Which of the following teams will win todays match?',
              color: '#FFFFFF',
              font: {
                size: '18',
                strength: '600',
                family: 'Outfit, sans-serif',
                align: 'center',
              },
            },
            type: 'none',
            imgPosition: 'bottom',
            imageError: '',
            questionError: '',
            image: {
              fileName: '',
              url: '',
            },
            audio: {
              fileName: '',
              url: '',
            },
            points: 0,
            correctOption: '',
            versusNeeded: false,
            optionType: 'Image',
            optionsList: [
              {
                text: 'Team A',
                color: '#ffffff',
                font: {
                  size: '16',
                  strength: '400',
                  family: 'Outfit, sans-serif',
                  align: 'center',
                },
                optionImage: {
                  fileName: '',
                  url: '',
                },
              },
              {
                text: 'Team B',
                color: '#ffffff',
                font: {
                  size: '16',
                  strength: '400',
                  family: 'Outfit, sans-serif',
                  align: 'center',
                },
                optionImage: {
                  fileName: '',
                  url: '',
                },
              },
              {
                text: 'Match will end in a draw',
                color: '#ffffff',
                font: {
                  size: '16',
                  strength: '400',
                  family: 'Outfit, sans-serif',
                  align: 'center',
                },
                optionImage: {
                  fileName: '',
                  url: '',
                },
              },
            ],
          },
        ],
        submissionConfig: {
          submissionIconImg: 'https://cdnstg.gamize.com/13/spinTheWheel/15/9152_Layer_1.png',
          submissionIconImgName: 'SubmissionIcon',
          submissionIconImgError: '',
          // timerColor: '#000000',
          timerHeader: {
            text: 'Results in',
            color: '#ffffff',
            font: {
              size: '14',
              strength: '400',
              family: 'Outfit, sans-serif',
              align: 'center',
            },
          },
          submissionText: {
            text: 'Submitted',
            color: '#ffffff',
            font: {
              size: '18',
              strength: '700',
              family: 'Outfit, sans-serif',
              align: 'center',
            },
          },
          ctaNeeded: true
        },
        libraries: {
          iconLibrary: [],
        },
        resultTitleWinning: {
          text: 'Your prediction was Right!!!',
          color: '#ffffff',
          font: {
            size: '16',
            strength: '700',
            family: 'Outfit, sans-serif',
            align: 'center',
          },
          error: ''
        },
        resultTitleLosing: {
          text: 'Your prediction was Wrong!!!',
          color: '#ffffff',
          font: {
            size: '16',
            strength: '700',
            family: 'Outfit, sans-serif',
            align: 'left',
          },
          error: ''
        },
        resultCtaNeeded: true,
        winingBackgroundImage: '',
        winingBackgroundImageName: '',
        winingBackgroundImageError: '',
        losingBackgroundImage: '',
        losingBackgroundImageName: '',
        losingBackgroundImageError: '',
        additionalSettings: {
          titleFontStyle: 'Outfit, sans-serif',
          titleFontWt: '700',
          titleFontSize: '16',
          titleFontColor: '#ffffff',
          subtitleFontStyle: 'Outfit, sans-serif',
          subtitleFontWt: '400',
          subtitleFontSize: '14',
          subtitleFontColor: '#ffffff',
          buttonFontStyle: 'Outfit, sans-serif',
          buttonFontWt: '400',
          buttonFontSize: '12',
          buttonFontColor: '#ffffff',
          backgroundColor1: '#000000',
          backgroundColor2: '#000000',

          winningText: '',
          winningTextError: '',
          winningImg: '',
          winningImgName: '',
          winningImgError: '',
          losingText: '',
          losingTextError: '',
          losingImg: '',
          losingImgName: '',
          losingImgError: '',

          winningWebURL: '',
          winningAppURL: '',
          losingWebURL: '',
          losingAppURL: '',
          rewardIcon: '',
          rewardIconName: '',
          selectedRewardIconIndex: 1,
          offerDetailsTitle: {
            text: ''
          },
          instructionsTitle: {
            text: ''
          },
          winningMsgFontStyle: 'Outfit, sans-serif',
          winningMsgFontWt: '400',
          winningMsgFontSize: '12',
          winningMsgFontColor: '#ffffff',
          losingMsgFontStyle: 'Outfit, sans-serif',
          losingMsgFontWt: '400',
          losingMsgFontSize: '12',
          losingMsgFontColor: '#ffffff',
          offerDetailsFontStyle: 'Outfit, sans-serif',
          offerDetailsFontWt: '400',
          offerDetailsFontSize: '12',
          offerDetailsFontColor: '#ffffff',
          instructionsFontStyle: 'Outfit, sans-serif',
          instructionsFontWt: '400',
          instructionsFontSize: '12',
          instructionsFontColor: '#ffffff',
        },
        themeConfig: {},
      }
    ]
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_IMAGE_REQUESTED: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }
    case UPLOAD_IMAGE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case UPLOAD_IMAGE_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case SAVE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case SAVE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case SAVE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case UPDATE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case DUPLICATE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }
    case DUPLICATE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case DUPLICATE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case GET_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case GET_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_FIELD: {
      state = state
        ? {
          ...state,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    case UPDATE_TITLE_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].title = state.config.localizationconfig[i].title
            ? {
              ...state.config.localizationconfig[i].title,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_SUBTITLE_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].subtitle = state.config.localizationconfig[i].subtitle
            ? {
              ...state.config.localizationconfig[i].subtitle,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_BACKGROUND_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].background = state.config.localizationconfig[i].background
            ? {
              ...state.config.localizationconfig[i].background,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_LAYER_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].scratchLayer = state.config.localizationconfig[i].scratchLayer
            ? {
              ...state.config.localizationconfig[i].scratchLayer,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_BUTTON_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].buttonFormat = state.config.localizationconfig[i].buttonFormat
            ? {
              ...state.config.localizationconfig[i].buttonFormat,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_BUTTON_FIELD_SCRATCH_CARD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].buttonFormatScratchCard = state.config.localizationconfig[i].buttonFormatScratchCard
            ? {
              ...state.config.localizationconfig[i].buttonFormatScratchCard,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_BUTTON_CONFIG: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i] = state.config.localizationconfig[i]
            ? {
              ...state.config.localizationconfig[i],
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_QUESTIONS_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i] = state.config.localizationconfig[i]
            ? {
              ...state.config.localizationconfig[i],
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_BUTTON: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i] = state.config.localizationconfig[i]
            ? {
              ...state.config.localizationconfig[i],
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_APPCONFIG_FIELD: {
      state.initialValues = state.initialValues
        ? {
          ...state.initialValues,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    case UPDATE_LOCALIZATION_FLAG: {
      return { ...state, localizationFlag: action.payload };
    }
    case UPDATE_ACTIVE_FLAG: {
      return { ...state, activeNavTab: action.payload };
    }
    case UPDATE_CONFIG_FIELD: {
      const localizationconfig = [...state.config.localizationconfig, ...action.payload.localizationconfig];
      const config = {
        ...state.config,
        localizationconfig
      };
      return { ...state, config };
    }
    case REMOVE_CONFIG: {
      return { ...state, config: action.payload };
    }
    case CLEAR_STATE: {
      return { ...initialState };
    }
    case UPDATE_COLLAPSE: {
      state.collapse = state.collapse
        ? {
          ...state.collapse,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    case UPDATE_ACTIVITY_COLLAPSE: {
      state.activityInnerCollapse = state.activityInnerCollapse
        ? {
          ...state.activityInnerCollapse,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    case UPDATE_GRATIFY_BACKGROUND_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].gratifyBackground = state.config.localizationconfig[i].gratifyBackground
            ? {
              ...state.config.localizationconfig[i].gratifyBackground,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_CARDCONFIG: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].cardConfig = state.config.localizationconfig[i].cardConfig
            ? {
              ...state.config.localizationconfig[i].cardConfig,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_LEADGEN_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].leadGeneration = state.config.localizationconfig[i].leadGeneration
            ? {
              ...state.config.localizationconfig[i].leadGeneration,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_FORMDISPLAY_CONFIG: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].formDisplayConfig = state.config.localizationconfig[i].formDisplayConfig
            ? {
              ...state.config.localizationconfig[i].formDisplayConfig,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_ADDSETTINGS_CONFIG: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].additionalSettings = state.config.localizationconfig[i].additionalSettings
            ? {
              ...state.config.localizationconfig[i].additionalSettings,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_DISPLAYWIZARD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].displayWizard = state.config.localizationconfig[i].displayWizard
            ? {
              ...state.config.localizationconfig[i].displayWizard,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    default:
      return state;
  }
};

export const updateTitle = (payload) => {
  return {
    type: UPDATE_TITLE_FIELD,
    payload,
  };
};

export const updateSubTitle = (payload) => {
  return {
    type: UPDATE_SUBTITLE_FIELD,
    payload,
  };
};

export const updateButtonFormat = (payload) => {
  return {
    type: UPDATE_BUTTON_FIELD,
    payload,
  };
};

export const updateButtonFormatScratchCard = (payload) => {
  return {
    type: UPDATE_BUTTON_FIELD_SCRATCH_CARD,
    payload,
  };
};

export const updateBackground = (payload) => {
  return {
    type: UPDATE_BACKGROUND_FIELD,
    payload,
  };
};
export const updateLayer = (payload) => {
  return {
    type: UPDATE_LAYER_FIELD,
    payload,
  };
};

export const uploadimage = (file, folderName) => {
  const accessToken = window.localStorage.getItem('access_token');
  return {
    types: [UPLOAD_IMAGE_REQUESTED, UPLOAD_IMAGE_SUCCESS, UPLOAD_IMAGE_FAILURE],
    promise: () => upload
      .post(`${APP_CONFIG.CURRENT_GAMIFICATION_HOST_NAME}/gamification/upload`)
      .withCredentials()
      .set({ has_auth_token: 1 })
      .set('Authorization', `Bearer ${accessToken}`)
      .attach('files', file)
      .field('folderName', folderName)
  };
};
// action
export const updateFields = (payload) => {
  return {
    type: UPDATE_FIELD,
    payload,
  };
};

export const updatePage = (payload) => {
  return {
    type: UPDATE_PAGE,
    payload,
  };
};

export const saveScratchCardConfig = (data) => {
  return {
    types: [SAVE_CONFIG_REQUESTED, SAVE_CONFIG_SUCCESS, SAVE_CONFIG_FAILURE],
    promise: client => client.post('saveScratchCardConfig', {
      data,
    }),
  };
};

export const editScratchCardConfig = (data, gamificationId) => {
  return {
    types: [UPDATE_CONFIG_REQUESTED, UPDATE_CONFIG_SUCCESS, UPDATE_CONFIG_FAILURE],
    promise: client => client.post(`saveScratchCardConfig?gamificationId=${gamificationId}`, {
      data,
    }),
  };
};

export const getScratchCardConfig = (data) => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get(`getSpinWheel?gamificationId=${data}`),
  };
};

export const duplicateSpinWheelTitle = (data, type, id) => {
  return {
    types: [DUPLICATE_CONFIG_REQUESTED, DUPLICATE_CONFIG_SUCCESS, DUPLICATE_CONFIG_FAILURE],
    promise: client => client.get(`duplicateSpinWheelTitle?title=${data}&type=${type}&id=${id}`)
  };
};

export const getTemplate = (data) => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get(`getTemplate?templateId=${data}`),
  };
};

export const updateDropdown = (payload) => {
  return {
    type: UPDATE_APPCONFIG_FIELD,
    payload,
  };
};

export const getAppConfig = () => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get('getAppConfig'),
  };
};

export const updateLocalizationFlag = (payload) => {
  return {
    type: UPDATE_LOCALIZATION_FLAG,
    payload,
  };
};


export const updateActiveFlag = (payload) => {
  return {
    type: UPDATE_ACTIVE_FLAG,
    payload,
  };
};

export const updateConfig = (payload) => {
  return {
    type: UPDATE_CONFIG_FIELD,
    payload
  };
};

export const removeConfig = (payload) => {
  return {
    type: REMOVE_CONFIG,
    payload
  };
};

export const clearState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const updateButton = (payload) => {
  return {
    type: UPDATE_BUTTON,
    payload
  };
};

export const updateButtonConfig = (payload) => {
  return {
    type: UPDATE_BUTTON_CONFIG,
    payload
  };
};


export const updateQuestions = (payload) => {
  return {
    type: UPDATE_QUESTIONS_FIELD,
    payload,
  };
};

export const updateCollapse = (payload) => {
  return {
    type: UPDATE_COLLAPSE,
    payload
  };
};

export const updateActivityCollapse = (payload) => {
  return {
    type: UPDATE_ACTIVITY_COLLAPSE,
    payload
  };
};

export const updateGratifyBackground = (payload) => {
  return {
    type: UPDATE_GRATIFY_BACKGROUND_FIELD,
    payload,
  };
};

export const updateCardConfig = (payload) => {
  return {
    type: UPDATE_CARDCONFIG,
    payload
  };
};

export const updateLeadGeneration = (payload) => {
  return {
    type: UPDATE_LEADGEN_FIELD,
    payload,
  };
};

export const updateFormDisplayConfig = (payload) => {
  return {
    type: UPDATE_FORMDISPLAY_CONFIG,
    payload,
  };
};

export const updateAdditionalSettings = (payload) => {
  return {
    type: UPDATE_ADDSETTINGS_CONFIG,
    payload,
  };
};

export const updateDisplayWizard = (payload) => {
  return {
    type: UPDATE_DISPLAYWIZARD,
    payload,
  };
};

export const saveSpinWheelConfig = (data) => {
  return {
    types: [SAVE_CONFIG_REQUESTED, SAVE_CONFIG_SUCCESS, SAVE_CONFIG_FAILURE],
    promise: client => client.post('saveSpinWheelConfig', {
      data,
    }),
  };
};

export const editSpinWheelConfig = (data, referralId) => {
  return {
    types: [UPDATE_CONFIG_REQUESTED, UPDATE_CONFIG_SUCCESS, UPDATE_CONFIG_FAILURE],
    promise: client => client.post(`saveSpinWheelConfig?gamificationId=${referralId}`, {
      data,
    }),
  };
};
